/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Upload_WebsitesInputs */

const en_features_upload_websites = /** @type {(inputs: Features_Upload_WebsitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Websites`)
};

const es_features_upload_websites = /** @type {(inputs: Features_Upload_WebsitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitios web`)
};

/**
* | output |
* | --- |
* | "Websites" |
*
* @param {Features_Upload_WebsitesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_upload_websites = /** @type {((inputs?: Features_Upload_WebsitesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Upload_WebsitesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_upload_websites(inputs)
	return en_features_upload_websites(inputs)
});